import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import InlineDropdown from '../InlineDropdown';
import Button, { IconButton } from '../Button';

function Pagination(props) {
  const {
    className,
    previousPage,
    totalPages,
    currentPage,
    gotoPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    itemsPerPage,
    changeItemsPerPage,
    showOutOf,
    showPageNumbers,
    bordered,
  } = props;

  let paginationItems = [];

  if (totalPages > 1) {
    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      if (number === 1 || number === totalPages || (number >= currentPage - 2 && number <= currentPage + 2)) {
        items.push(
          <Button size='xs' variant='' key={number} className="pgn__pagination-item" active={number - 1 === currentPage} onClick={() => gotoPage(number - 1)}>
            {number}
          </Button>,
        );
      } else if (number === 2 || number === totalPages - 1) {
        items.push(<BootstrapPagination.Ellipsis key={number} className="pgn__pagination-item" />);
      }
    }
    paginationItems = items;
  }

  const paginationContent = (
    <div className={classNames('pgn__pagination-wrapper', className)}>
      {showOutOf && <div className="pgn__pagination-left">
        <span className="pgn__pagination-left-text" data-testid="page-numbers">Page {currentPage + 1} of {totalPages}</span>
      </div>}
      <div className="pgn__pagination-body">
        <BootstrapPagination className="pgn__pagination-item-root">
          <IconButton icon='arrow-left-double' iconType='line' variant='' size='xs' className="pgn__pagination-item" onClick={() => gotoPage(0)} disabled={!canPreviousPage} data-testid="pagination-left-first-btn" />
          <IconButton icon='arrow-left-s' iconType='line' variant='' size='xs' onClick={() => previousPage()} disabled={!canPreviousPage} className="pgn__pagination-item" data-testid="pagination-left-prev-btn" />

          {paginationItems}

          <IconButton icon='arrow-right-s' iconType='line' variant='' size='xs' onClick={() => nextPage()} disabled={!canNextPage} className="pgn__pagination-item" data-testid="pagination-right-next-btn" />
          <IconButton icon='arrow-right-double' iconType='line' variant='' size='xs' className="pgn__pagination-item" onClick={() => gotoPage(totalPages - 1)} disabled={!canNextPage} data-testid="pagination-right-last-btn" />
        </BootstrapPagination>

      </div>
      {showPageNumbers && <div className="pgn__pagination-right" data-testid="pagination-inline-dropdown">
        <InlineDropdown selected={`${itemsPerPage} / page`} border className="pgn__pagination-dropdown">
          <InlineDropdown.Item label="1 / page" onClick={() => changeItemsPerPage(1)} />
          <InlineDropdown.Item label="3 / page" onClick={() => changeItemsPerPage(3)} />
          <InlineDropdown.Item label="6 / page" onClick={() => changeItemsPerPage(6)} />
          <InlineDropdown.Item label="10 / page" onClick={() => changeItemsPerPage(10)} />
          <InlineDropdown.Item label="20 / page" onClick={() => changeItemsPerPage(20)} />
          <InlineDropdown.Item label="50 / page" onClick={() => changeItemsPerPage(50)} />
          <InlineDropdown.Item label="100 / page" onClick={() => changeItemsPerPage(100)} />
        </InlineDropdown>
      </div>}
    </div>
  );

  return bordered ? (
    <div className="pgn__pagination-container">
      {paginationContent}
    </div>
  ) : paginationContent;
}

Pagination.propTypes = {
  previousPage: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  gotoPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  changeItemsPerPage: PropTypes.func.isRequired,
  className: PropTypes.string,
  showOutOf: PropTypes.bool,
  showPageNumbers: PropTypes.bool,
  bordered: PropTypes.bool,
};

Pagination.defaultProps = {
  className: '',
  showOutOf: false,
  showPageNumbers: false,
  bordered: false,
};

export default Pagination;
